module.exports = __webpack_public_path__ + "e855a050.png";